module.exports = __webpack_public_path__ + "static/media/arrow_outward.eea650c8.svg";